import styled, { css } from 'styled-components';
import { buttonBase } from '../styled.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { getButtonAppearance } from '../utils/getButtonAppearance.js';
import { getIconButtonSize } from '../utils/getIconButtonSize.js';

var IconButton = styled.button.withConfig({
  displayName: "IconButton",
  componentId: "sc-qndgzd-0"
})(["", ";", " ", ";", ";"], buttonBase, function (props) {
  return props.$round && css(["border-radius:", ";"], themeGet('borderRadius.circle'));
}, function (props) {
  return getButtonAppearance(props.appearance);
}, function (props) {
  return getIconButtonSize(props.size);
});

export { IconButton };
